import AppHeader, { AppWrapper } from '../../components/AppView';
import AppBody from '../AppBody';
import {
  TOKEN_ADDRESS,SIMPLESAWP_ADDRESS, USDT_ADDRESS,LOCKED_ADDRESS
} from '../../constants/address';
import { useCallback, useEffect, useMemo, useState } from 'react';
import NumericalInput from '../../components/NumericalInput';
import Row,{RowBetween} from '../../components/Row';
import {
   ButtonPrimary,
} from '../../components/Button';

import { AutoColumn } from '../../components/Column';
import styled, { useTheme } from 'styled-components';

import { Trans } from '@lingui/macro';

import useLocked from '../../hooks/useLocked';

import Loader from '../../components/Loader';
import { fromAmount, toAmount, toSpecialAmount } from "../../utils/amount";

import { useWallet } from 'use-wallet';

import useERC20Balance from '../../hooks/useERC20Balance';
import useToken from '../../hooks/useToken';

import Big from 'big.js';
import { ZERO_ADDRESS } from '../../utils/ethereum';
import Modal from '../../components/Modal';
import { LoadingView, SubmittedView } from '../../components/ModalViews';
import PromoteBanner from '../../components/PromoteBanner';



const LabelWrapper = styled.div`
  font-size: 14px;
`;
const InputText = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const Symbol = styled.div`
  margin-left: 8px;
`;
const Span = styled.span`
 color: ${ ({ theme }) => theme.warning };
`;
const BalanceWrapper = styled.div`
  padding: 4px 2px;
  font-size: 14px;
`;

function Locked() {
  const {
    chainId,
    account,
    balance,
  } = useWallet();
  // const theme = useTheme();
  const {
    lockedBalance,
    withdraw,
    getLokedRule,
    lockedTokens,
    deposit,
    balanceOf,
    getPledgeList,
    adminWithdraw,

  } = useLocked(LOCKED_ADDRESS[chainId]);

  //const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState('');
  const [lokedRule, setLokedRule] = useState({gapdays:'0',pledgedays:'0',startprenum:'0'});
  


  const [loading, setLoading] = useState(false);
  const [isSubmitShow, setIsSubmitShow] = useState(false);
  const [submitHash, setSubmitHash] = useState('');
  const [submitError, setSubmitError] = useState('');

  const [token] = useToken(TOKEN_ADDRESS[chainId]);
  const tokenContract = useMemo(() => {
    if (token) {
      return token.contract;
    }
    return null;
  }, [token]);

  const isValid = useMemo(() => {
    if (value) {

      return new Big(value).gt( toSpecialAmount(lockedBalance?lockedBalance.canwithdrawbalance:0,18));
    }
    return true;
  }, [value,lockedBalance]);

  useEffect(() => {
    const fetch = async () => {
      try {
        //const outs = await miniSwap.methods.getSwapTokens().call();
        const out = await getLokedRule();
        setLokedRule(out);

      } catch (e) {
        console.log(e);
      }
    };


      fetch();
    
    return () => {};
  }, [chainId,account,getLokedRule]);

  const tokenBalance = useERC20Balance(tokenContract, account);
  
  const ErrFun=(e)=>{
    if (e){
      setSubmitError(e.message);
    } else {
      setValue('');
    }
  }
  const handleWithdraw = useCallback(async () => {
   
    setIsSubmitShow(true);
    setSubmitHash('');
    setSubmitError('');
    try {
      const tx = await withdraw(fromAmount(value,18),setLoading,tokenContract.address!=ZERO_ADDRESS,ErrFun);
      tx && setSubmitHash(tx.hash);
    } catch (e) {
      console.log(e);
      setSubmitError(e.message);
    } 
  }, [
    value,
    tokenContract,
    withdraw
  ]);

  return (
    <>
    
      <AppBody>
        <AppHeader>
          <Trans>Withdraw</Trans>
        </AppHeader>
        <AppWrapper>
          <AutoColumn gap={ 'sm' }>
            <AutoColumn gap={ '2px' }>
            <AutoColumn gap={ 'sm' }>
            <LabelWrapper>
            <Trans>Wallet Balance: {  toSpecialAmount(tokenBalance,18)  || '0' }</Trans> { 'PRT' }
            </LabelWrapper>
          
            <RowBetween>
              <LabelWrapper>Withdraw  Amount:</LabelWrapper> 
              <LabelWrapper>Unlock Balance: <Span>{ (lockedBalance&& toSpecialAmount(lockedBalance.canwithdrawbalance,18))  ||'0' }</Span>{ 'PRT' } </LabelWrapper> 
              </RowBetween>
            
           
                <InputText value={ value }
                           onUserInput={ setValue } />

          </AutoColumn>
          
              <BalanceWrapper>
                <Trans>All Amount:<Span> { (lockedBalance && toSpecialAmount(lockedBalance.allamount,18)) || '0' }</Span></Trans> { ' PRT' }
              </BalanceWrapper>
              <BalanceWrapper>
               <Trans>Locked Balance: <Span>{ (lockedBalance && toSpecialAmount(lockedBalance.lockedammout,18))  ||'0' }</Span></Trans> { ' PRT' } 
              </BalanceWrapper>

              
              <BalanceWrapper>
                <Trans>Locked Days:<Span> { (lokedRule && lokedRule.pledgedays) || '0' }</Span></Trans> { 'DAY' }
              </BalanceWrapper>
              <BalanceWrapper>
               <Trans>Release Interval Days: <Span>{ (lokedRule && lokedRule.gapdays)  ||'0' }</Span></Trans> { 'DAY' } 
              </BalanceWrapper>
                <BalanceWrapper>
               <Trans>{'initial release Ratio:'} <Span>{ (lokedRule&& lokedRule.startprenum)  ||'0' }</Span></Trans>{ '%' }
              </BalanceWrapper>
            </AutoColumn>
              <ButtonPrimary
                disabled={ loading || isValid} onClick={ handleWithdraw }>

               
                  <Trans>withdraw</Trans> 

                { loading ? <Loader /> : null }
              </ButtonPrimary>
            
          </AutoColumn>
        </AppWrapper>

        <Modal isOpen={ isSubmitShow }
               onDismiss={ () => setIsSubmitShow(false) }>
          { loading ? (
            <LoadingView onDismiss={ () => setIsSubmitShow(false) } />
          ) : (
            <SubmittedView onDismiss={ () => setIsSubmitShow(false) }
                           hash={ submitHash }>
              { submitError ? (
                submitError
              ) : <Trans>Withdraw Succeeded.</Trans> }
            </SubmittedView>
          ) }
        </Modal>
      </AppBody>
    </>
  );
}

export default Locked;
